var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconTravel(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "102px",
    height: "88px",
    viewBox: "0 0 102 88",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Illustrative-/-Travel",
    transform: "translate(-13.000000, -20.000000)",
    stroke: "#000000",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("path", {
    className: "icon-line--style",
    d: "M82.9737,90.3466511 L70.5997,77.9716511 L72.0127,71.3296511 L78.6547,69.9166511 L91.0297,82.2916511 L82.9737,90.3466511 Z M111.2847,63.2786511 L51.9917,63.2786511 C50.4907,63.2786511 49.2747,64.4936511 49.2747,65.9936511 L49.2747,104.013651 C49.2747,105.514651 50.4907,106.730651 51.9917,106.730651 L111.2847,106.730651 C112.7847,106.730651 113.9997,105.514651 113.9997,104.013651 L113.9997,65.9936511 C113.9997,64.4946511 112.7837,63.2786511 111.2847,63.2786511 Z M95.4474,63.2787511 L95.4474,59.1007511 C95.4474,55.3127511 92.3644,52.2287511 88.5764,52.2287511 L74.6984,52.2287511 C70.9104,52.2287511 67.8264,55.3127511 67.8264,59.1007511 L67.8264,63.2787511 M48.378,53.4472511 L53.415,63.2792511 L63.057,63.2792511 L58.936,42.8932511 L74.001,27.8242511 C75.563,26.2622511 75.563,23.7312511 74.001,22.1722511 C72.441,20.6122511 69.909,20.6062511 68.346,22.1722511 L53.28,37.2392511 L17.142,29.9292511 L14,33.0722511 L42.725,47.7912511 L28.016,62.5012511 L20.253,60.9322511 L17.11,64.0732511 L27.022,69.1542511 L32.099,79.0632511 L35.242,75.9202511 L33.67,68.1532511 L48.378,53.4472511 Z",
    id: "Travel"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTravel);
export default __webpack_public_path__ + "static/media/icon-travel.6aa78514.svg";
export { ForwardRef as ReactComponent };